// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__FSjW9","container":"styles_container__3xmbH","title":"styles_title__9OKwq","wrapper":"styles_wrapper__343sf","answer":"styles_answer__2wFpy"};